module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mdl-layout__content use-backdrop"
  }, [_vm._m(0), _vm._v(" "), (_vm.$root.isSurveyorCapability() || _vm.$root.isRentalCapability() || _vm.$root.isRentalCheckCapability() || _vm.$root.isEuropcarCapability() || _vm.$root.isAldCapability()) ? _c('router-link', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored",
    attrs: {
      "id": "new-assessment",
      "to": {
        name: 'report-new'
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('h1', {
    staticClass: "section-header"
  }, [_vm._v("AUTOTAKST")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "section-content mdl-cell--8-col-tablet"
  }, [_c('p', [_vm._v("Visuell Inspeksjon og Teknisk Inspeksjon - VI og TI")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73a03824"}!./~/vue-loader/lib/selector.js?type=template&index=0!./reports/assets/src/components/Index.vue
// module id = 69
// module chunks = 0